import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=734048ef&scoped=true&"
import script from "./Step1.vue?vue&type=script&lang=js&"
export * from "./Step1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734048ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('734048ef')) {
      api.createRecord('734048ef', component.options)
    } else {
      api.reload('734048ef', component.options)
    }
    module.hot.accept("./Step1.vue?vue&type=template&id=734048ef&scoped=true&", function () {
      api.rerender('734048ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/alteration/Step1.vue"
export default component.exports